import lodash from 'lodash'
import store from '@/store'
import userHelper from '@/utils/userHelper'
import { UserDomain, UserSource } from '@/utils/consts'
import { contactTypes, contactInfoMap } from './consts'
import { getVendorDetailByIdAndSite } from './request'

export function getSecurityEmail (user) {
  return user.username
}

export function getUserProfileName (user) {
  const contacts = lodash.get(user, ['contacts'])
  const result = getUserContactItem(contacts, contactTypes.NAME)
  return result
}

export function getUserEmail (user) {
  const contacts = lodash.get(user, ['contacts'])
  const result = getUserContactItem(contacts, contactTypes.EMAIL)
  return result
}

export function getUserProfileEmail (user) {
  const contacts = lodash.get(user, ['contacts'])
  const result = getUserContactItem(contacts, contactTypes.PROFILE_EMAIL)
  return result
}

export function getUserProfilePhoneNumber (user) {
  const contacts = lodash.get(user, ['contacts'])
  const result = getUserContactItem(contacts, contactTypes.PROFILE_PHONE_NUMBER)
  return result
}

export function getUserContactItem (contacts, type) {
  let userContactItem
  if (Array.isArray(contacts) && contacts.length > 0) {
    userContactItem = contacts.find((contact) => contact.type === type)
  }

  let result
  if (userContactItem) {
    result = lodash.get(userContactItem, ['value'], '')
  } else {
    result = ''
  }
  return result
}

export function updateUserProfileEmail (user, newValue) {
  const contacts = lodash.get(user, ['contacts'])
  const newContacts = updateUserContactItem(contacts, contactTypes.PROFILE_EMAIL, newValue)
  lodash.set(user, ['contacts'], newContacts)
}

export function updateUserProfilePhoneNumber (user, newValue) {
  const contacts = lodash.get(user, ['contacts'])
  const newContacts = updateUserContactItem(contacts, contactTypes.PROFILE_PHONE_NUMBER, newValue)
  lodash.set(user, ['contacts'], newContacts)
}

function updateUserContactItem (contacts, type, newValue) {
  let newContacts
  let userContactItem
  if (Array.isArray(contacts) && contacts.length > 0) {
    newContacts = contacts
    userContactItem = newContacts.find((contact) => contact.type === type)
  } else {
    newContacts = []
  }

  if (userContactItem) {
    lodash.set(userContactItem, ['value'], newValue)
  } else {
    const newItem = {
      type,
      value: newValue,
    }
    newContacts.push(newItem)
  }
  return newContacts
}

export function getPrimaryEmail (user = {}) {
  const primaryEmailContact = deep(lodash.sortBy(
    (user.contacts || []).filter(contact => contact.type === contactTypes.EMAIL),
    ['priority'],
  ).reverse(), '0')
  return primaryEmailContact ? primaryEmailContact.value : user.username
}

export function updatePrimaryEmailContact (user, newEmail, id) {
  if (id) {
    const primaryEmail = user.contacts.find(contact => contact.id === id)
    deep(primaryEmail, 'value', newEmail)
  } else {
    const emails = lodash.sortBy(
      user.contacts.filter(contact => contact.type === contactTypes.EMAIL),
      ['priority'],
    ).reverse()
    if (emails[0]) {
      emails[0].value = newEmail
      emails[0].priority = 1
    } else {
      user.contacts.push({
        type: contactTypes.EMAIL,
        value: newEmail,
        priority: 1,
      })
    }
  }
}

export function getPrimaryPhoneNumberContact (user = {}) {
  return deep(lodash.sortBy(
    (user.contacts || []).filter(contact => contact.type === contactTypes.PHONE_NUMBER),
    ['priority'],
  ).reverse(), '0') || { value: '' }
}

export function updatePrimaryPhoneNumberContact (user, newPhoneNumber, id) {
  if (id) {
    const primaryPhoneNumber = user.contacts.find(contact => contact.id === id)
    deep(primaryPhoneNumber, 'value', newPhoneNumber)
  } else {
    const phoneNumbers = lodash.sortBy(
      user.contacts.filter(contact => contact.type === contactTypes.PHONE_NUMBER),
      ['priority'],
    ).reverse()
    if (phoneNumbers[0]) {
      phoneNumbers[0].value = newPhoneNumber
    } else {
      user.contacts.push({
        type: contactTypes.PHONE_NUMBER,
        value: newPhoneNumber,
        priority: 1,
      })
    }
  }
}

export async function getCurrentVendorAdmin (siteCode, vendorId) {
  if (!vendorId) {
    const currentUser = store.getters['user/currentUser']
    vendorId = currentUser.externalId
  }
  const [venderDetail] = await getVendorDetailByIdAndSite(vendorId, siteCode)
  return venderDetail
}

export function handleUserContacts (account) {
  const adminUser = lodash.cloneDeep(account.users.find(user => user.primary))
  const result = { enabled: false }
  if (adminUser) {
    result.enabled = adminUser.enabled
    adminUser.contacts = lodash.sortBy(adminUser.contacts, ['priority']).reverse().reduce((tmpResult, contact) => {
      tmpResult[contact.type] = tmpResult[contact.type] || []
      tmpResult[contact.type].push(contact.value)
      return tmpResult
    }, {})
  }
  const accountWithPrimaryUser = Object.assign({}, account, { users: [adminUser] })
  Object.entries(contactInfoMap).forEach(([key, value]) => {
    mapObjectValues(result, [key], accountWithPrimaryUser, value)
  })

  if (!result.contactAdmin && adminUser) {
    result.contactAdmin = userHelper.getUserName(adminUser.username, adminUser.displayName)
  }
  result.addressLine1 = account.address1
  result.addressLine2 = account.address2
  result.addressLine3 = account.address3
  result.addressLine4 = account.address4

  return result
}

export function mapObjectValues (toObj, toPath, fromObj, fromPath) {
  let i = 0
  for (; i < fromPath.length; i += 1) {
    if (!fromObj[fromPath[i]]) {
      fromObj[fromPath[i]] = {}
    }
    fromObj = fromObj[fromPath[i]]
  }
  let j = 0
  for (; j < toPath.length - 1; j += 1) {
    if (!toObj[toPath[j]]) {
      toObj[toPath[j]] = {}
    }
    toObj = toObj[toPath[j]]
  }
  toObj[toPath[j]] = lodash.isEmpty(fromObj) ? '' : lodash.cloneDeep(fromObj)
}

export function isEXTUser (user) {
  return user && user.source === UserSource.EXT
}

export function isCMSUser (user) {
  return user && user.domain === UserDomain.CMS
}

export function isEXTAndCMSUser (user) {
  return user && isCMSUser(user) && isEXTUser(user)
}
